import React, { useRef } from 'react';
import { StyledPosition } from './styles';
import { useChoir } from './hooks';
import PageLoader from '../../../components/PageLoader';
import Seo from '../../../../common/helpers/seo';
import ApplicationForm from './ApplicationForm';
import General from './General';
import Details from './Details';
import Additional from './Additional';
import { scrollTo } from './utils';

const Choir = () => {
    const { choir } = useChoir();
    const applicationFormRef = useRef<HTMLDivElement>();
    const scrollToApply = () => {
        const headerHeight = 50;
        const scrollToTop = applicationFormRef.current.getBoundingClientRect().top + window.scrollY - headerHeight;
        scrollTo(scrollToTop, 1200);
    }
    if (choir === 'error') {
        // TODO: error handling
        return <StyledPosition>
            <h2>Hiba történt a kérés teljesítése közben</h2>
        </StyledPosition>
    }
    if (!choir) {
        return (
            <>
                <PageLoader />
            </>
        )
    }
    return (
        <StyledPosition marginTop={50} withShadow>
            <Seo
                title={choir.name}
                ogTitle={choir.name}
                ogDescription={choir.meta.general.description}
                description={choir.meta.general.description}
                type='article'
            />
            <General choir={choir} scrollToApply={scrollToApply} />
            <Additional additional={choir.meta.additional} scrollToApply={scrollToApply} />
            <Details choir={choir} />
            <ApplicationForm choir={choir} applicationFormRef={applicationFormRef} />
        </StyledPosition>
    );
};

export default Choir;
